import { createElement, forwardRef } from 'react';
import '../../index.scss';
import { ProTable as OriginalTable, TableDropdown } from '@ant-design/pro-components';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useRef } from 'react';
const ProTable = (props, ref) => {
    const actionRef = useRef();
    const formRef = useRef();
    const { actionColumn, actionColumnButtons, columns, requestUrl, ...others } = props;
    function runColumnActionCallback(param) {
        const { callback, text, record, _, action } = param;
        try {
            if (callback) {
                return Promise.resolve(callback(text, record, _, action));
            }
        }
        catch (e) {
            if (e instanceof Error) {
                console.warn(e.stack);
            }
        }
        return Promise.reject();
    }
    ;
    const renderActionColumnButtons = (actionColumn, actionColumnButtons) => {
        const { dataSource, visibleButtonCount } = actionColumnButtons;
        const showMoreAction = dataSource.length > visibleButtonCount;
        const actionColumnButtonsToRender = dataSource.slice(0, (showMoreAction ? visibleButtonCount - 1 : undefined));
        const remainActions = dataSource.slice(visibleButtonCount - 1);
        const menu = remainActions.map((action) => {
            return {
                key: action.key,
                name: action.name,
                onClick: action.onClick
            };
        });
        return {
            ...actionColumn,
            valueType: 'option',
            key: 'option',
            width: actionColumn.width,
            render: (text, record, _, action) => {
                const _actionColumnButtonsToRender = actionColumnButtonsToRender.map((buttonProps) => {
                    return (createElement(Button, Object.assign({}, buttonProps, { onClick: (e) => {
                            e.stopPropagation();
                            runColumnActionCallback({ callback: buttonProps.onClick, text, record, _, action }).finally(() => {
                                console.log('finally');
                            });
                        } }), buttonProps.name));
                });
                const showMoreoRender = showMoreAction && menu.length ?
                    createElement(TableDropdown, { key: "actionGroup", menus: menu }) : [];
                return [..._actionColumnButtonsToRender, showMoreoRender];
            }
        };
    };
    const renderColunms = (columns) => {
        const _actionColumnButtons = renderActionColumnButtons(actionColumn, actionColumnButtons);
        const _columns = columns.map(column => {
            return column;
        });
        console.log(99, [..._columns, _actionColumnButtons]);
        return [..._columns, _actionColumnButtons];
    };
    return (createElement(OriginalTable, Object.assign({ ref: ref, actionRef: actionRef, formRef: formRef, columns: renderColunms(columns), pagination: {
            pageSize: 5,
            onChange: (page) => console.log(page),
        }, toolBarRender: () => [
            createElement(Button, { key: "button", icon: createElement(PlusOutlined, null), onClick: () => {
                    console.log('test11', actionRef, formRef);
                    actionRef.current?.reload();
                }, type: "primary" }, "\u65B0\u5EFA"),
        ] }, others)));
};
export default forwardRef(ProTable);
